<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 3rem;">
      <el-tabs v-model="tabCurr">
        <el-tab-pane label="列表" name="list"></el-tab-pane>
        <!-- <el-tab-pane label="明细" name="detail"></el-tab-pane> -->
      </el-tabs>
    </el-header>
    <detail v-if="tabCurr=='detail'"></detail>
    <el-main style="padding: 0px" v-if="tabCurr=='list'">
      <el-container class="f-h">
        <el-header class="toolbar" style="height: 2.5rem">
          <el-row type="flex" justify="space-between">
            <div class="sub-title">
              <el-button icon="el-icon-s-promotion" @click="setVisible('结算查询')" size="small" type="warning" class="left-pad">结算查询<small> {{ settleDates.endDate }}</small></el-button>
              <el-button icon="el-icon-s-claim" @click="setVisible('临时日结')" size="small" type="primary" class="left-pad">
                临时日结
              </el-button>
            </div>
            <div>
              <el-date-picker v-model="timeRange" size="small" type="datetimerange" :picker-options="meta.pickerOptions" range-separator="至" start-placeholder="日结开始时间" end-placeholder="日结结束时间" align="right" @change="timeRangeChanged" />
              <el-button icon="el-icon-search" @click="queryEntities" size="small" :disabled="searchLoading" class="left-pad">查询</el-button>
            </div>
          </el-row>
        </el-header>
        <el-main style="padding: 0px">
          <el-table :data="entities.items" stripe height="96%" v-loading="searchLoading">
            <el-table-column label="操作" width="90" align="center">
              <!-- <template slot-scope="scope" style="border: inline;">
                <el-button type="primary" icon="el-icon-search" title="查看" circle plain size="mini" @click="info(scope.row, scope.$index)"></el-button>
                <el-popconfirm title="确定要反日结吗？" @confirm="del(scope.row, scope.$index)" iconColor="red" style="margin-left:5px;margin-right:5px;">
                    <el-button slot="reference" type="danger" icon="el-icon-delete" title="反日结" circle plain size="mini"></el-button>
                </el-popconfirm>
            </template> -->
              <template v-slot='scope'>
                <el-button type="primary" icon="el-icon-search" title="查看" circle plain size="mini" @click="handlePrint(scope.row, true)"></el-button>
                <el-button type="primary" icon="el-icon-printer" title="打印" circle plain size="mini" @click="handlePrint(scope.row, false)"></el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column label="收费员"></el-table-column> -->
            <el-table-column label="账单开始时间" min-width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.accountStartDate | fmtDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="日结结束时间" min-width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.accountEndDate | fmtDateTime }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="流水号" prop="no" min-width="100" show-overflow-tooltip align="center" /> -->
            <!-- <el-table-column label="挂号数" align="center" prop="regTotal"></el-table-column> -->
            <!-- <el-table-column label="退号数" align="center" prop="unRegTotal"></el-table-column> -->
            <el-table-column label="结算总额" min-width="100" align="center">
              <template v-slot="scope">
                {{ scope.row.chgAmount | fmtFloat }}
              </template>
            </el-table-column>
            <el-table-column label="收款合计" min-width="100" align="center">
              <template v-slot="scope">
                {{ (scope.row.chgAmount + scope.row.rfdAmount) | fmtFloat }}
              </template>
            </el-table-column>
            <el-table-column label="退款合计" min-width="100" align="center">
              <template v-slot="scope">
                {{ scope.row.rfdAmount | fmtFloat }}
              </template>
            </el-table-column>
            <el-table-column label="结账时间" min-width="100" align="center">
              <template v-slot="scope">
                {{ scope.row.execStartDate| fmtDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="收费员" prop="createUserName" align="center">
            </el-table-column>
          </el-table>
          <pagination :entities='entities' @queryEntities='queryEntities' :condition='condition' />
          <info :visible.sync="meta.showInfo" v-model="entity" />
        </el-main>
      </el-container>
    </el-main>
    <!-- 结算查询、临时日结 弹窗 -->
    <modal
      v-if="visible"
      :visible.sync="visible"
      :title="modalTitle"
      :dateStart="settleStart"
      :dateEnd="settleEnd"
      @refresh="showPage"
    />
    <el-dialog :visible="dialogVisible" @close="close" width="50em">
      <template slot="title">
        <strong>门诊日结详情</strong>
      </template>
      <print-table
        :dataInvoice="printData.dataInvoice"
        :dataByFee="printData.dataByFee"
        :dataByPay="printData.dataByPay"
        :amountObj="printData.amountObj"
        :timeRange="printData.timeRange"
        :feeAmount="printData.feeAmount"
        :issueDate="printData.issueDate"
        :userName="printData.user"
      />
      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>

    <div v-if="printData.user" style="height: 0; overflow: hidden">
      <print-table
        ref="printTable"
        :dataInvoice="printData.dataInvoice"
        :dataByFee="printData.dataByFee"
        :dataByPay="printData.dataByPay"
        :amountObj="printData.amountObj"
        :timeRange="printData.timeRange"
        :feeAmount="printData.feeAmount"
        :issueDate="printData.issueDate"
        :userName="printData.user"
      />
    </div>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
import api from "./api";

const printTable = () => import(/* webpackChunkName: 'printTable' */ './printTable');
export default {
  components: {
    pagination: () => import('@/components/_com/pagination'),
    modal: () => import('./modal.vue'),
    info: () => import('./info.vue'),
    detail: () => import('./detail'),
    printTable
  },
  data () {
    return {
      visible: false,
      dialogVisible: false,
      modalTitle: '',
      meta: {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        showInfo: false
      },
      searchLoading: false,
      settleDates: {},
      settleTime: this.$utils.fmtTime(Date.now()),
      timeRange: null,
      execSettlmentIng: false,
      condition: {
        sort: "accountEndDate",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20,
        accountStartDate: null,
        accountEndDate: null
      },
      entities: {
        items: []
      },
      entity: {},
      tabCurr: 'list',
      printData: {
        dataInvoice: null,
        dataByFee: [],
        dataByPay: [],
        amountObj: {
          amount: 0, // 应支付总额
          cash: 0, // 实际支付总额
          fund: 0, // 医保支付总额
          discount: 0 // 折扣总额
        },
        feeAmount: null,
        issueDate: null,
        user: null,
        payAmount: null,
      },
    };
  },
  computed: {
    ...mapGetters(["dict", "dictEnum", "permission", "user"]),
    settleStart: function () {
      return this.settleDates.startDateTime || this.settleDates.startDate;
    },
    settleEnd: function () {
      return this.settleDates.endDate + ' ' + this.settleTime;
    },
    selectableRange () {
      const time = moment(new Date()).format('HH:mm:ss')
      return `00:00:00 - ${time}`
    },
    amountDiff() {
      return this.$utils.fmtFloat(this.payAmount - this.feeAmount, 2);
    },
  },
  created () {
    this.showPage();
  },
  methods: {
    showPage () {
      this.queryCurSettleDate();
      this.queryEntities();
    },
    queryCurSettleDate () {
      api.getCurrentSettleDate().then(res => {
        this.settleDates = res;
      }).catch(err => {
        this.$message({
          type: 'error',
          message: '日结期间获取失败！'
        });
      });
    },
    queryEntities () {
      this.searchLoading = true;
      api.queryEntities(this.condition).then(res => {
        this.entities = res;
        if (!res.items || res.items.length == 0) {
          this.$message({
            message: '没有符合条件的日结记录',
            type: 'info'
          });
        }
      }).catch(err => {
        this.$message.error("发生查询错误，请联系管理员。");
        console.log(err);
      }).finally(() => {
        this.searchLoading = false;
      });
    },
    timeRangeChanged (range) {
      if (range && range.length > 0) {
        this.condition.accountStartDate = range[0];
      } else {
        this.condition.accountStartDate = null
      }
      if (range && range.length > 1) {
        this.condition.accountEndDate = range[1];
      } else {
        this.condition.accountEndDate = null
      }
    },
    info (row, index) {
      this.meta.showInfo = true;
      this.entity = row;
    },
    del (row, index) {
      api.deleteClosing(row.id).then(() => {
        this.$message({
          message: '删除成功！',
          type: 'success'
        });
        this.queryEntities();
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    // 日结单打印
    async handlePrint (row, isView) {
      this.printData.user = row.createUserName;
      this.printData.timeRange = [row.accountStartDate, row.accountEndDate];
      this.printData.issueDate = await this.$utils.getServerTime();

      const queryPara = {
        cashierId: row.createUserId,
        closingStartTime: row.accountStartDate,
        closingEndTime: row.accountEndDate
      };
      this.searchLoading = true;
      api.getCashierFeeType(queryPara) // api.getRpFeeType({ dailyAccountIds: [row.id] })
        .then(({ items }) => {
          if (!Array.isArray(items)) return;
          this.printData.dataByFee = items; // 项目
          this.feeAmount = items.map(r => r.amount).reduce((p, c) => p + c, 0);
          this.printData.feeAmount = this.feeAmount;
          return api.getCahierPayType(queryPara); // 各 收费类型
        })
        .then(items => {
          if (items && items.length) {
            items.forEach((i) => {
              const find = this.dict.PayWay.find(p => p.code === i.type);
              // 支付类型对应的名称
              if (find) { i.type = find.name }
              if (i.type === 'med') {
                i.type = '医保';
              }
            });
            this.printData.dataByPay = items;
            this.payAmount = this.$utils.fmtFloat(items.map(r => r.amount).reduce((p, c) => p + c, 0), 2);
            this.printData.dataByPay.push({ type: '货币误差', amount: this.amountDiff });
          }
          return api.getCahierInvoices(queryPara); // 发票数
        })
        .then(res => {
          if (Array.isArray(res)) {
            this.printData.dataInvoice = {
              chargeInvoiceList: res.chargeInvoiceList || [],
              refundAmount: res.refundAmount || 0,
              chargeInvoiceCount: res.chargeInvoiceCount || 0,
              refundInvoiceCount: res.refundInvoiceCount || 0,
            };
          }
          return api.getAccount(queryPara) // 应支付总额、医保支付总额、折扣总额、实际支付总额
        })
        .then(res => {
          if (res && res.amount) {
            this.printData.amountObj = res;
          }
        })
        .catch(err => this.$message.error(err))
        .finally(() => {
          this.dialogVisible = isView;
          this.searchLoading = false;
          if (!isView && this.$refs.printTable) {
            this.$refs.printTable.printFn();
            setTimeout(() => this.printData.user = '', 300);
          }
        });
    },
    setVisible (val) {
      this.modalTitle = val;
      if (this.settleTime) {
        this.visible = true;
      } else {
        this.$message.info('请设置日结结束时间。');
      }
    },
    close() {
      this.dialogVisible = false;
    }
  },
};
</script>
<style>
.el-main {
  padding-top: 0;
}
</style>